<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <div class="d-flex justify-content-between mb-5">
        <div>
            <label for="information" class="labelInformation">
                Threshold Settings
            </label>
        </div>
        <div class="col btn-back text-end">
            <button class="btn btn-secondary" type="button" aria-label="Back to home" (click)="goBack()">Back</button>
        </div>
    </div>
    <div>
        @for (thresholdSetting of thresholdSettings; track thresholdSetting.settingId) {
        <div class="mb-3 d-flex justify-content-between">
            <label for="flexSwitchCheckDefault">{{ getAttributeId(thresholdSetting.attributeId) }}</label>
            <div class="form-check form-switch">
                <input type="checkbox" id="flexSwitchCheckDefault" [checked]="thresholdSetting.value === '1'" (change)="onToggleChange($event, thresholdSetting)" class="form-check-input ng-pristine ng-valid ng-touched">
            </div>
        </div>    
    }
        
    </div>
   



</div>